async function search (e) {
  const $form = e.target.closest('form')
  const { value } = e.target

  if (value === '') {
    $form.querySelector('form#custom-search .search-results').classList.remove('show')
    return
  }

  try {
    const response = await fetch(`/search/suggest.json?q=${value}&resources[type]=query,product&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,variants.title&`)
    const { resources: { results } } = await response.json()
    const { queries, products } = results

    if (queries.length > 0 || products.length > 0) {
      $form.querySelector('form#custom-search .search-results').classList.add('show')
    } else {
      $form.querySelector('form#custom-search .search-results').classList.remove('show')
      return
    }

    $form.querySelector('form#custom-search footer a').href = `/search?q=${value}&options%5Bprefix%5D=last`
    $form.querySelector('form#custom-search footer a span').innerHTML = `Search for "${value}"`

    const $resultsSuggestions = $form.querySelector('.results-suggestions')
    $resultsSuggestions.innerHTML = '<li class="title-results">Suggestions</li>'

    for (const query of queries) {
      const { url, styled_text } = query

      const content = `
      <li>
        <a href="${url}">
          ${styled_text}
        </a>
      </li>
      `

      $resultsSuggestions.insertAdjacentHTML('beforeend', content)
    }

    const $resultsProducts = $form.querySelector('.results-products')
    $resultsProducts.innerHTML = '<li class="title-results">Products</li>'

    for (const product of products) {
      const { url, title, price, featured_image } = product
      const { url: imageUrl, alt } = featured_image

      const formatter = new Intl.NumberFormat(Shopify.country, {
        style: 'currency',
        currency: Shopify.currency.active,
      });

      const content = `
      <li>
        <a href="${url}" class="item-product">
          ${imageUrl != null ? `<img src="${imageUrl}" width="50" height="50" alt="${alt}">` : ''}

          <div>
            <span class="product-title">${title}</span>
            <span class="product-price">${formatter.format(price).replace('JP', '')} ${Shopify.currency.active}</span>
          </div>
        </a>
      </li>
      `

      $resultsProducts.insertAdjacentHTML('beforeend', content)
    }
  } catch (error) {
    console.log(error)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  $customFormSearches = document.querySelectorAll('form#custom-search')
  $customSearches = document.querySelectorAll('form#custom-search input')

  for (const $customSearch of $customSearches) {
    $customSearch.addEventListener('input', search)
  }

  function handleClickOutside(event) {
    $customFormSearches.forEach(form => {
      if (!form.contains(event.target)) {
        form.querySelector('.search-results').classList.remove('show')
        form.querySelector('input').value = ''
      }
    });
  }
  
  document.addEventListener('click', handleClickOutside);
})
